import { render, staticRenderFns } from "./UserDepositMngtList.vue?vue&type=template&id=04cc4d3c"
import script from "./UserDepositMngtList.vue?vue&type=script&lang=js"
export * from "./UserDepositMngtList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports